// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"625":"b379f806","775":"e86ee1cb"}[chunkId] + ".css";
};